import { Grid, Theme, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import React from "react";
import MyTheme from "../../../assets/theme/MyTheme";
import AppInitSingletonBo from "../../../consumer/init/AppInitSingletonBo";
import { getKampagneImage, getKampagneText } from "../../../consumer/init/dto/StvKampagne";
import useCssMediaQuery from "../../useCssMediaQuery";


const useStyle = makeStyles((theme: Theme) => ({
    subtitle1: {
        fontFamily: theme.typography.subtitle1.fontFamily
    },

    kampagneLogoImg: {
        display: 'block',
        transition: MyTheme.transition.all,
        width: 125,
        height: 'auto',
        left: 5,
        top: -30,

        // xs (max-width: 599.95px)    
        [theme.breakpoints.down('sm')]: {
            width: 100,
            left: 0,
            top: 100
        },

    },
}));



const Kampagne: React.FC = () => {
    const classes = useStyle();
    const cssMediaQuery = useCssMediaQuery();

    // Abbruch
    const kampagne = AppInitSingletonBo.kampagne;
    if (!kampagne) {
        return null;
    }

    const kampagneTxt = getKampagneText(kampagne);
    const kampagneImg = getKampagneImage(kampagne);

    const TextCmp: React.FC = () => (
        <Typography color='secondary' variant='body2' style={{
            textAlign: 'center', fontWeight: 'bold', whiteSpace: 'pre-wrap'
        }}>
            <span className={classes.subtitle1}>NEU: </span>{kampagneTxt}
        </Typography >
    );

    const ImgCmp: React.FC<{ cssImgStyle?: React.CSSProperties, cssRootStyle?: React.CSSProperties }> = ({ cssImgStyle, cssRootStyle }) => (
        <div style={cssRootStyle}>
            <img className={classes.kampagneLogoImg} src={kampagneImg} alt="Kampagne" style={cssImgStyle} />
        </div>
    );

    return (<>
        {
            // Mobile Version
            cssMediaQuery.mobileVersion ?
                <Grid container alignContent='center' justifyContent='center' spacing={2}>
                    <Grid item xs={12} md={12}>
                        <ImgCmp cssRootStyle={{ display: 'flex', justifyContent: 'center' }} />
                    </Grid>
                    <Grid item xs={12} md={12}>
                        <TextCmp />
                    </Grid>
                </Grid>
                : // Desktop Version
                <div style={{ display: 'flex' }}>
                    <TextCmp />
                    <ImgCmp cssRootStyle={{ position: 'relative' }} cssImgStyle={{ position: 'absolute' }} />
                </div>
        }
    </>);
}

export default Kampagne;